/**
 * Load plugin configs via import.meta.glob so Vite includes them in production
 * builds. The matched files must exist under packages/plugins/ at `vite build`
 * time (CI copies alpha-beton-webui there); otherwise the maps stay empty.
 * Paths are relative to this file (packages/hit-base/src/utils/).
 */
const pluginMenus = import.meta.glob('../../../plugins/*/config/menu.js');
const pluginPanels = import.meta.glob('../../../plugins/*/config/panel.js');
const pluginRouters = import.meta.glob('../../../plugins/*/config/router.js');

function findPluginLoader(modules, plugin, configFile) {
  const suffix = `/plugins/${plugin}-webui/config/${configFile}`;
  const exact = `../../..${suffix}`;
  if (modules[exact]) {
    return modules[exact];
  }
  // Tolerate alternate relative keys if Vite resolves via symlink realpath.
  const match = Object.keys(modules).find((key) => key.endsWith(suffix));
  return match ? modules[match] : null;
}

async function loadPluginConfig(modules, plugin, configFile) {
  const loader = findPluginLoader(modules, plugin, configFile);
  if (!loader) {
    throw new Error(
      `Plugin "${plugin}" config "${configFile}" was not included in this WebUI build. ` +
        `Ensure packages/plugins/${plugin}-webui exists when running vite build ` +
        `(use the alphawebui CI job / scripts/build_alphawebui_local.sh).`,
    );
  }
  return loader();
}

export function loadPluginMenu(plugin) {
  return loadPluginConfig(pluginMenus, plugin, 'menu.js');
}

export function loadPluginPanel(plugin) {
  return loadPluginConfig(pluginPanels, plugin, 'panel.js');
}

export function loadPluginRouter(plugin) {
  return loadPluginConfig(pluginRouters, plugin, 'router.js');
}
